import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiUser, FiBell, FiWifi, FiShield, FiDatabase } from 'react-icons/fi';

const SettingToggle = ({ label, desc, active }) => (
  <div className="flex items-center justify-between py-4 border-b border-steel-100 last:border-0">
    <div>
      <div className="font-medium text-steel-900">{label}</div>
      <div className="text-xs text-steel-500 mt-0.5">{desc}</div>
    </div>
    <div className={`w-10 h-5 rounded-full p-0.5 transition-colors cursor-pointer ${active ? 'bg-tomato-500' : 'bg-steel-200'}`}>
      <div className={`w-4 h-4 rounded-full bg-white shadow-sm transform transition-transform ${active ? 'translate-x-5' : 'translate-x-0'}`} />
    </div>
  </div>
);

export const Settings = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6 max-w-3xl"
    >
      <header className="mb-8">
        <h1 className="text-2xl font-bold text-steel-900 tracking-tight">System Preferences</h1>
        <p className="text-steel-500">Manage your CookCircuit environment.</p>
      </header>

      <div className="panel">
        <div className="panel-header"><SafeIcon icon={FiWifi} className="mr-2 inline" /> Connected Appliances</div>
        <div className="p-4 space-y-4 text-sm">
          <div className="flex justify-between items-center p-3 bg-steel-50 rounded border border-steel-200">
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-green-500"></div>
              <span className="font-medium text-steel-900">Smart Oven X1</span>
            </div>
            <span className="text-xs font-mono text-steel-500">192.168.1.42</span>
          </div>
          <div className="flex justify-between items-center p-3 bg-steel-50 rounded border border-steel-200">
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-green-500"></div>
              <span className="font-medium text-steel-900">Induction Hub Pro</span>
            </div>
            <span className="text-xs font-mono text-steel-500">192.168.1.43</span>
          </div>
          <button className="text-tomato-500 text-sm font-medium hover:text-tomato-600 transition-colors">
            + Pair New Device
          </button>
        </div>
      </div>

      <div className="panel">
        <div className="panel-header"><SafeIcon icon={FiBell} className="mr-2 inline" /> Notifications & Automation</div>
        <div className="px-4">
          <SettingToggle label="Prep Reminders" desc="Receive alerts when it's time to start cooking." active={true} />
          <SettingToggle label="Low Stock Alerts" desc="Auto-generate shopping list when thresholds are met." active={true} />
          <SettingToggle label="Appliance Sync" desc="Automatically pre-heat appliances based on recipe timing." active={false} />
        </div>
      </div>

      <div className="panel">
        <div className="panel-header"><SafeIcon icon={FiDatabase} className="mr-2 inline" /> Data & Privacy</div>
        <div className="px-4">
           <SettingToggle label="Cloud Sync" desc="Sync meal plans across all household devices." active={true} />
           <SettingToggle label="Diagnostic Data" desc="Send anonymous usage data to improve CookCircuit algorithms." active={false} />
        </div>
      </div>

      <div className="mt-12 text-center pb-8">
        <div className="w-12 h-12 bg-steel-200 rounded-full mx-auto mb-4 flex items-center justify-center text-steel-500">
          <SafeIcon icon={FiShield} className="text-xl" />
        </div>
        <p className="text-sm font-medium text-steel-900">CookCircuit OS v2.4</p>
        <p className="text-xs text-steel-500 mt-1">Made by LingLink AI and DigLab AI</p>
      </div>

    </motion.div>
  );
};